import { imageAsset, link } from '@/data/sanity/fragments'
import cmsSettings from '../cmsSettings'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  sectionBackground,
  title,
  ${imageAsset.fragment('image', true)},
  ${link.fragment('cta')},
  ${link.fragment('secondaryCta')},
  phoneNumber,
  email,
  hours,
  holidayHours,
  timeZone
`

export const fragment = (name = 'guestServicesHero') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
